import React from 'react';
import PropTypes from 'prop-types';
import PanelsRun from './panels.run';

class Panel extends React.Component {
    componentDidMount() {
        PanelsRun();
    }

    headerGenerator() {
        let {
            header,
            closeable,
            refreshable,
            collapsible,
            icon,
            headerComponents
        } = this.props;

        let closeableButton = (
            // eslint-disable-next-line
            <a
                href="#"
                data-tool="panel-dismiss"
                data-toggle="tooltip"
                title="Close Panel"
                className="pull-right"
            >
                <em className="fa fa-times" />
            </a>
        );

        let refreshableButton = (
            // eslint-disable-next-line
            <a
                href="#"
                data-tool="panel-refresh"
                data-toggle="tooltip"
                title="Refresh Panel"
                data-spinner="traditional"
                className="pull-right"
            >
                <em className="fa fa-refresh" />
            </a>
        );

        let collapsibleButton = (
            // eslint-disable-next-line
            <a
                href="#"
                data-tool="panel-collapse"
                data-toggle="tooltip"
                title="Collapse Panel"
                className="pull-right"
            >
                <em className="fa fa-minus" />
            </a>
        );

        const panelHeader = (
            <div className="panel-heading">
                {icon && <span className={icon} />}
                {header ? header : ''}
                {closeable && closeableButton}
                {collapsible && collapsibleButton}
                {refreshable && refreshableButton}
                <div className="btn-toolbar pull-right">{headerComponents}</div>
            </div>
        );

        return panelHeader;
    }

    footerGenerator() {
        let { footerComponents } = this.props;

        const panelFooter = (
            <div className="panel-footer">
                <div className="btn-toolbar">{footerComponents}</div>
            </div>
        );

        return panelFooter;
    }

    render() {
        let { showHeader, showFooter, panelStyle, collapsible } = this.props;

        let panelBody = (
            <div>
                <div className="panel-body">{this.props.children}</div>
                {showFooter && this.footerGenerator()}
            </div>
        );

        if (showHeader && collapsible) {
            panelBody = (
                <div className="panel-wrapper collapse in">
                    <div className="panel-body">{this.props.children}</div>
                    {showFooter && this.footerGenerator()}
                </div>
            );
        }

        return (
            <div
                style={this.props.styleObject}
                className={
                    panelStyle
                        ? 'panel panel-demo ' + panelStyle
                        : 'panel panel-demo panel-default'
                }
            >
                {showHeader && this.headerGenerator()}
                {panelBody}
            </div>
        );
    }
}

Panel.propTypes = {
    icon: PropTypes.string,
    showHeader: PropTypes.bool,
    header: PropTypes.string,
    showFooter: PropTypes.bool,
    footerComponents: PropTypes.array,
    headerComponents: PropTypes.array,
    collapsible: PropTypes.bool,
    closeable: PropTypes.bool,
    refreshable: PropTypes.bool,
    panelStyle: PropTypes.string,
    styleObject: PropTypes.object
};

Panel.defaultProps = {
    showHeader: false,
    showFooter: false,
    header: 'Panel Header',
    footerComponents: null,
    headerComponents: null,
    panelStyle: 'panel-default',
    styleObject: null,
    collapsible: false,
    closeable: false,
    refreshable: false
};

export default Panel;



// WEBPACK FOOTER //
// ./src/components/angle/Panel/index.js